<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" title="新建装箱单" width="1300px">
      <section>
        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
          <!-- 每行显示 2 个 el-form-item -->
          <el-row :gutter="20">
            <!-- 选择用户 -->
            <el-col :span="12">
              <el-form-item label="选择用户" prop="userId">
                <el-select v-model="form.userId" filterable clearable placeholder="请选择用户" @change="handleUserChange">
                  <el-option
                      v-for="user in userList"
                      :key="user.id"
                      :label="user.userName"
                      :value="user.userId"
                  >
                    <span style="float: left">{{ user.userName }}
                    <span v-if="user.remarkCustomerName" style="font-size: 13px; margin-left: 5px;">( {{ user.remarkCustomerName }} )</span>
                    </span>
                </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 收件地址 -->
            <el-col :span="12">
              <el-form-item label="收件地址" prop="id">
                <el-select v-model="form.id" filterable clearable placeholder="请选择收件地址">
                  <el-option
                      v-for="address in receiveAddressList"
                      :key="address.id"
                      :label="address.detailedAddresserInfo"
                      :value="address.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 发货地址 -->
            <!--          <el-col :span="12">
                        <el-form-item label="发货地址">
                          <el-select v-model="form.ids" filterable clearable placeholder="请选择发货地址">
                            <el-option
                              v-for="address in sendAddressList"
                              :key="address.id"
                              :label="address.detailedAddresserInfo"
                              :value="address.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>-->

            <!-- 线路 -->
            <el-col :span="12">
              <el-form-item label="线路" prop="route">
                <el-select v-model="form.route" filterable clearable placeholder="请选择线路" @change="handleRouteChange">
                  <el-option
                      v-for="route in routeList"
                      :key="route.id"
                      :label="route.name"
                      :value="route.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 物流公司 -->
            <el-col :span="12">
              <el-form-item label="物流公司" prop="logisticsCompanyId">
                <el-select v-model="form.logisticsCompanyId" filterable clearable placeholder="请选择物流公司" @change="handleLogisticsCompanyChange">
                  <el-option
                      v-for="company in filteredLogisticsCompanyList"
                      :key="company.id"
                      :label="company.companyName"
                      :value="company.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 备注 -->
            <el-col :span="12">
              <el-form-item label="备注">
                <el-input
                    v-model="form.comments"
                    type="input"
                    :rows="2"
                    placeholder="请输入备注"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 上传附件 -->
            <!--          <el-col :span="12">-->
            <!--            <el-form-item label="上传附件">-->
            <!--              <el-upload-->
            <!--                :action="packingApis.upload"-->
            <!--                :on-success="handleUploadSuccess"-->
            <!--                :on-error="handleUploadError"-->
            <!--              >-->
            <!--                <el-button type="primary">点击上传</el-button>-->
            <!--              </el-upload>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->
          </el-row>
        </el-form>

        <!-- 选择商品表格 -->
        <el-table
            ref="goodsTableRef"
            :data="goodsList"
            @select="handleSelect"
            @select-all="handleSelectAll"
            :height="360"
            row-key="id"
        >
          <el-table-column type="selection" reserve-selection width="30">
          </el-table-column>
          <el-table-column type="index" label="序号" width="55" align="center" />
          <el-table-column label="订单号" prop="id" align="center" />
          <el-table-column label="图片" align="center" prop="pictureUrl">
            <template #default="{ row }">
              <el-image :src="row.pictureUrl" width="100px" height="100px" @click="chackImg(row)" />
            </template>
          </el-table-column>
          <el-table-column label="商品规格" width="180" prop="refundCount" align="left">
            <template #default="{ row }">
              <div>
                {{ row.colourCn || row.colour }}

              </div>
              <div>
                {{ row.goodsSizeCn || row.goodsSize }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发送方式" prop="route" align="center" width="70">
            <template #default="{ row }">
              <div v-if="row.route">{{ row.route == 1 ? '空运' : '海运' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="商品数量" prop="goodsCount" align="center" width="70"/>
          <el-table-column label="销毁" prop="destroyCount" align="center" width="50"/>
          <el-table-column label="收货地址" prop="receiverAddress" align="center" width="190">
            <template #default="{ row }">
              <div class="flex-column align-start">
                <div class="font-style">
                  <span class="left">收件人</span>
                  <span>：</span>
                  <span class="right">{{ row.receiver }}</span>
                </div>
                <div class="font-style">
                  <span class="left">联系电话</span>
                  <span>：</span>
                  <span class="right">{{ row.receiverPhone }}</span>
                </div>
                <div class="font-style">
                  <span class="left">邮编</span>
                  <span>：</span>
                  <span class="right">{{ row.zipCode }}</span>
                </div>
                <div class="font-style">
                  <span class="left">详细地址</span>
                  <span>：</span>
                  <span class="right">{{ row.receiverAddress }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="可申请" prop="canApplyCount" align="center" width="60"/>
          <el-table-column label="申请数量" align="center">
            <template #default="{ row }">
              <el-input type="number" isInteger v-model="row.containerGoodsCount"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" width="120" prop="orderStatus" align="center">
            <template #default="{ row }">
              <!-- {{ returnStatus(row.orderStatus) }} -->
              {{ row.orderStatus | orderStatusFilter }}
            </template>
          </el-table-column>
          <el-table-column label="退货" prop="refundCount"  align="center" width="50"/>
          <el-table-column label="采购/检品工作签" prop="staffRemark" align="center" width="200">
            <template #default="{ row }">
              <el-input type="textarea"   v-model="row.staffRemark" readonly size="small"></el-input>
              <el-input style="padding-top: 5px" type="textarea"   readonly v-model="row.checkRemark" size="small"></el-input>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </section>

      <span slot="footer" class="dialog-footer">
      <el-button @click="cancelForm('form')">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('form')">确 定</el-button>
    </span>


    </el-dialog>
    <!-- 图片预览 -->
    <el-dialog
        :visible.sync="dialogImgVisible"
        v-if="dialogImgVisible"
        width="30%"
    >
      <img :src="dialogPic" width="100%" height="100%" />
    </el-dialog>
  </div>
</template>

<script>
import { packingApis } from './packing'

export default {
  name: 'packingOrder',
  data() {
    return {
      packingApis,
      dialogVisible: false, // 控制对话框显示
      orderStatusMap: {
        "-1": '待支付',
        "1": '待购买',
        "2": '购买完',
        "0": '等待到库',
        "4": '已到库',
        "8": '检品中',
        "16": '仓库保管',
        "24": '不良待处理',
        "26": '不良驳回',
        "28": '换货待发回',
        "32": '换货等待到货',
        "36": '待部分退货',
        "40": '补发等待到货',
        "48": '待发送',
        "52": '已发送',
        "56": '已取消',
        "60": '退货申请中',
        "64": '退货待支付',
        "68": '待退货',
        "72": '已退货',
        "76": '销毁申请中',
        "80": '销毁待支付',
        "82": '待部分销毁',
        "83": '待销毁',
        "84": '已销毁',
        "88": '检品完',
        "89": '无法购买',
        "999": '无法购买'
      },
      form: {
        userId: '', // 用户ID
        id: '', // 收件地址ID
        ids: 413, // 发货地址ID
        route: '', // 线路ID
        logisticeCompany: '',
        logisticsCompanyId: '', // 物流公司ID
        comments: '', // 备注
        attachment: '', // 附件
        listOrderJson: '', // 选中商品
      },
      // 前置验证
      rules: {
          userId: [
            { required: true, message: '请选择用户', trigger: 'change' }
          ],
          id: [
            { required: true, message: '请选择收件地址', trigger: 'change' }
          ],
          route: [
            { required: true, message: '请选择线路', trigger: 'change' }
          ],
          logisticsCompanyId: [
            { required: true, message: '请选择物流公司', trigger: 'change' }
          ],
      },
      userList: [], // 用户列表
      receiveAddressList: [], // 收件地址列表
      sendAddressList: [], // 发货地址列表
      routeList: [
        { id: 1, name: '空运' },
        { id: 2, name: '海运' }
      ], // 线路列表（固定为“空运”和“海运”）
      allLogisticsCompanyList: [], // 所有物流公司列表
      goodsList: [], // 商品列表
      currentPage: 1, // 当前页码
      pageSize: 20, // 每页显示条数
      total: 0, // 总条数
      multipleSelection: [],
      dialogPic: undefined,
      dialogImgVisible: false,
    }
  },
  computed: {
    // 根据线路筛选物流公司
    filteredLogisticsCompanyList() {
      if (!this.form.route) return this.allLogisticsCompanyList // 如果没有选择线路，返回全部
      const selectedRoute = this.routeList.find(route => route.id === this.form.route)
      return this.allLogisticsCompanyList.filter(company => company.line === (selectedRoute.id === 1 ? '空运' : '海运'))
    }
  },
  created() {
    this.fetchUserList()
    this.fetchLogistics()
  },
  methods: {
    // 查看图片
    chackImg(row) {
      this.dialogImgVisible = true;
      this.dialogPic = row.pictureUrl;
    },
    openPacking() {
      this.dialogVisible = true
      this.form = {
        userId: '', // 用户ID
        id: '', // 收件地址ID
        ids: 413, // 发货地址ID
        route: '', // 线路ID
        logisticsCompany: '',
        logisticsCompanyId: '', // 物流公司ID
        comments: '', // 备注
        attachment: '', // 附件
        listOrderJson: '', // 选中商品
      }
      this.goodsList = []
      this.multipleSelection = []
      this.$refs.goodsTableRef.clearSelection()
    },
    hidePacking() {
      this.dialogVisible = false
    },
    // 获取全部用户
    async fetchUserList() {
      try {
        const response = await this.$http.get(packingApis.customr)
        if (response.data) {
          this.userList = response.data.data && response.data.data.length ? response.data.data: []
        } else {
          this.userList = []
        }
        console.log('所有用户', response)
      } catch (error) {
        console.error('获取用户列表失败', error)
      }
    },

    // 选择用户
    async handleUserChange(userId) {
      this.form.userId = userId
      this.form = {
        userId,
        id: '',
        ids: 413,
        route: '',
        logisticsCompany: '',
        logisticsCompanyId: '',
        comments: '',
        attachment: '',
        listOrderJson: '',
      }
      this.currentPage = 1
      this.multipleSelection = [];
      this.$refs.goodsTableRef.clearSelection()
      await this.fetchGoodsList(userId)
      await this.fetchReceiveAddressList(userId)
      await this.fetchSendAddressList(userId)
    },

    // 根据用户获取商品
    async fetchGoodsList(userId) {
      try {
        const response = await this.$http.post(packingApis.goods, { userId, pageNum: this.currentPage, pageSize: this.pageSize })
        if (response.data.data) {
          this.goodsList = response.data.data.list && response.data.data.list.length ? response.data.data.list : []
          this.total = response.data.data.total
        } else {
          this.goodsList = []
          this.total = 0
        }
      } catch (error) {
        console.error('获取商品列表失败', error)
      }
    },

    // 根据用户获取收件地址
    async fetchReceiveAddressList(userId) {
      try {
        const response = await this.$http.post(packingApis.obtainAddress, { userId })
        if (response.data) {
          this.receiveAddressList = response.data.data && response.data.data.length ? response.data.data : []
          for (let i = 0; i < this.receiveAddressList.length; i++) {
            if(this.receiveAddressList[i]?.defaultAddress === '1'){
              this.form.id = this.receiveAddressList[i].id
            }
          }
        } else {
          this.receiveAddressList = []
        }
      } catch (error) {
        console.error('获取收件地址列表失败', error)
      }
    },

    // 根据用户获取发货地址
    async fetchSendAddressList(userId) {
      try {
        const response = await this.$http.post(packingApis.sendAddress, { userId })
        if (response.data) {
          this.sendAddressList = response.data.data && response.data.data.length ? response.data.data : []
        } else {
          this.sendAddressList = []
        }
      } catch (error) {
        console.error('获取发货地址列表失败', error)
      }
    },

    // 获取物流公司地址
    async fetchLogistics() {
      try {
        const response = await this.$http.post(packingApis.logistics)
        if (response.data) {
          this.allLogisticsCompanyList = response.data.data && response.data.data.length ? response.data.data : []
        } else {
          this.allLogisticsCompanyList = []
        }
      } catch (error) {
        console.error('获取物流公司地址失败', error)
      }
    },

    // 切换线路
    handleRouteChange(routeId) {
      console.log(routeId);
      this.form.logisticsCompanyId = '' // 清空物流公司选择
    },

    // 选择物流公司
    handleLogisticsCompanyChange(companyId) {
      const selectedCompany = this.filteredLogisticsCompanyList.find(company => company.id === companyId);
      if (selectedCompany) {
        this.form.logisticeCompany = selectedCompany.companyName;
      } else {
        this.form.logisticeCompany = '';
      }
    },

    // 上传附件成功
    handleUploadSuccess(response, file, fileList) {
      this.form.attachment = response.data
      this.$message.success('上传成功')
      console.log(response.data)
    },

    // 上传附件失败
    handleUploadError(err, file, fileList) {
      this.$message.error('上传失败')
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pageSize = size
      this.fetchGoodsList(this.form.userId)
    },

    // 当前页码改变
    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchGoodsList(this.form.userId)
    },

    // 表格多选
    handleSelectionChange(val) {
      console.log(val);

      val.forEach((item) => {
        item.containerGoodsCount = item.canApplyCount;
      });
      this.multipleSelection = val;
    },
    handleSelect(selection, row) {
      // console.log(selection,123, row);
      selection.forEach((item) => {
        if(item.id == row.id){
          item.containerGoodsCount = row.canApplyCount;
        }
      });
      this.multipleSelection = selection;
    },
    handleSelectAll(selection) {
      // console.log(selection,456);
      selection.forEach((item) => {
        item.containerGoodsCount = item.canApplyCount;
      });
      this.multipleSelection = selection;
    },

    // 提交表单
    handleSubmit(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (!valid) {
            console.log('error submit!!');
            return false;
          }
          if(this.multipleSelection==''){
            return this.$message({
                showClose: true,
                message: '请选择商品',
                type: 'error'
              });
          }
          try {
            const params = {
            ...this.form,
            listOrderJson: JSON.stringify(this.multipleSelection)
            }
            const response = await this.$http.post(packingApis.submit, params)
            if (response.data.code == 200) {
              this.$message.success('提交成功')
              this.dialogVisible = false
              this.$refs[formName].resetFields();
              this.$emit('success')
            } else {
              this.$message.error(response.data.message)
            }
          } catch (error) {
            console.error('提交失败', error)
            this.$message.error('提交失败')
          }
        })
      },
      // 取消表单
      cancelForm(formName) {
        this.dialogVisible = false
        this.$refs[formName].resetFields();
      },
    },
  }


    // 提交表单
//     async handleSubmit() {
//       if (this.multipleSelection.length == 0) {
//         this.$message.error('请选择用户')
//         return false
//       }
//       try {
//         const params = {
//           ...this.form,
//           listOrderJson: JSON.stringify(this.multipleSelection)
//         }
//         const response = await this.$http.post(packingApis.submit, params)
//         if (response.data.code == 200) {
//           this.$message.success('提交成功')
//           this.dialogVisible = false
//           this.$emit('success')
//         } else {
//           this.$message.error(response.data.message)
//         }
//       } catch (error) {
//         console.error('提交失败', error)
//         this.$message.error('提交失败')
//       }
//     }
//   }
// }
</script>

<style scoped lang="less">
.el-dialog__body {
  padding: 20px;
}
.el-form-item {
  margin-bottom: 20px;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.font-style {
  display: flex;
  justify-content: center;
  width: 100%;
  // justify-content: space-between;
  .left {
    display: flex;
    justify-content: flex-end;
    width: 58px;
    // min-width: 40px;
  }
  .right {
    max-width: calc(100% - 90px);
    min-width: 25px;
    text-align: left;
    flex: 1;
    // display: flex;
    // justify-content: flex-end;
    // flex-wrap: nowrap;
  }
  .text-over {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
